import classNames from "classnames";
import moment from "moment";
import React from "react";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2F1 } from "../../../../../redux/app/bfl-2/groups/bfl2-f";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2F1PreviewProps = OwnProps;
function BFL2E1Preview(props: BFL2F1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2F1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "F", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.locationWhereShipWasInspected
					? biofoulingRecord.item1.locationWhereShipWasInspected
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.contingencyActions
					? biofoulingRecord.item2.contingencyActions
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item3.dateWhenShipCompletedReactiveCleaning
					? `${moment(
							biofoulingRecord.item3.dateWhenShipCompletedReactiveCleaning
					  ).format("DD-MMM-YYYY")} (SMT)`
					: "-----"}
			</h4>
		);
	}

	return renderMain();
}

export default BFL2E1Preview;
